// Loading.js
import React from 'react';

const Loading = () => {
    const styles = {
        container: {
            display: 'flex', 
            flexDirection: 'column', // Stack items vertically
            alignItems: 'center', 
            justifyContent: 'center', 
            height: '100vh', 
            background: 'white', 
            color: 'black', 
            textAlign: 'center',
        },
        video: {
            width: '400px', 
            height: 'auto', // Maintain aspect ratio
            marginTop: '0px', // Add spacing between logo and video
        }
    };

    return (
        <div style={styles.container}>
            <img src={require("./screens/Logo.png")} width={400} alt="Logo" />
            <video 
                src={require('./loading_vid.mp4')} 
                autoPlay 
                loop 
                muted 
                style={styles.video}
            />
        </div>
    );
};

export default Loading;